import axios from "axios";
import * as Types from "./types";

import { manageError } from "../utils/axiosResponseError";
import { showSuccess } from "../utils/configToast";

export const retrieveProspectAction = (user) => async (dispatch) => {
	let responseData;
	await axios
		.get("prospector/list")
		.then((res) => {
			responseData = res.data;
			dispatch({
				type: Types.PROSPECT_RETRIEVE,
				payload: {
					response: responseData,
					error: {},
				},
			});
		})
		.catch((error) => {
			manageError(error);
		});

	return responseData;
};
